<mat-dialog-content>
	<p>
		{{message}}
	</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1">{{'yes' | translate}}</button>
	<button mat-raised-button mat-dialog-close tabindex="-1">{{'cancel' | translate}}</button>
</mat-dialog-actions>